<template>
  <button class="mobile-navigator-timeline"
          @click="openTimeline"
  >
    <span :class="{'has-filters-indicator': beforeYear !== null}">
      <app-icon icon="timeline-label"
                :is-active="isTimelineOpen"
      />
    </span>
  </button>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "MobileNavigatorItemTimeline",
  computed: {
    ...mapState('Interface', ['isTimelineOpen']),
    ...mapState('Filters', ['beforeYear'])
  },
  methods: {
    openTimeline() {
      this.$emit('before-toggle')

      if (this.$bp.isMdOrLess && !this.isTimelineOpen) {
        this.closeAllMenus()
      }

      this.setTimelineOpenState(!this.isTimelineOpen)
    },

    ...mapActions('Interface', ['setTimelineOpenState', 'closeAllMenus'])
  }
}
</script>